"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const manifest_1 = require("../manifest");
const _appearance_1 = require("./_appearance");
/**
 * Shop by brand — a clone of `category-grid` for brands. Two modes:
 *  - `brands`: pick which store brands to show (or all); each tile pulls the
 *    brand's logo + links to its brand page.
 *  - `custom`: hand-built tiles (upload image + label + link) via `tile` blocks.
 */
(0, manifest_1.registerSection)({
    type: 'brand-grid', label: 'Shop by brand', icon: 'award', category: 'products',
    settingsSchema: zod_1.z.object({
        title: zod_1.z.string().max(120).default('Shop by brand'),
        eyebrow: zod_1.z.string().max(60).default('Browse'),
        source: zod_1.z.enum(['brands', 'custom']).default('brands'),
        columns: zod_1.z.number().int().min(2).max(6).default(4),
        limit: zod_1.z.number().int().min(1).max(24).default(12),
        brandIds: zod_1.z.array(zod_1.z.string()).default([]), // empty => all brands
        ..._appearance_1.appearanceShape,
    }),
    blockTypes: {
        tile: { label: 'Tile', icon: 'image', max: 24,
            settingsSchema: zod_1.z.object({
                imageUrl: zod_1.z.string().default(''),
                label: zod_1.z.string().max(80).default(''),
                href: zod_1.z.string().default('/brands'),
            }) },
    },
    maxBlocks: 24,
    defaults: () => ({ title: 'Shop by brand', eyebrow: 'Browse', source: 'brands', columns: 4, limit: 12, brandIds: [], ...(0, _appearance_1.appearanceDefaults)() }),
    fields: [
        { name: 'title', label: 'Title', control: 'text', group: 'Content' },
        { name: 'eyebrow', label: 'Eyebrow', control: 'text', group: 'Content' },
        { name: 'source', label: 'Show', control: 'select', group: 'Content', options: [
                { label: 'Store brands', value: 'brands' }, { label: 'Custom tiles', value: 'custom' },
            ] },
        { name: 'brandIds', label: 'Brands', control: 'brand-ids', group: 'Content', showWhen: { field: 'source', equals: 'brands' } },
        { name: 'columns', label: 'Columns', control: 'number', min: 2, max: 6, group: 'Content' },
        { name: 'limit', label: 'Max tiles', control: 'number', min: 1, max: 24, group: 'Content', showWhen: { field: 'source', equals: 'brands' } },
        ..._appearance_1.appearanceFields,
    ],
    blockFields: {
        tile: [
            { name: 'imageUrl', label: 'Image', control: 'image' },
            { name: 'label', label: 'Label', control: 'text' },
            { name: 'href', label: 'Link (button) URL', control: 'url' },
        ],
    },
});
//# sourceMappingURL=brand-grid.js.map